import { MARQUEE_ITEMS } from "@/lib/data";

export const Marquee = () => {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div
      data-testid="trust-marquee"
      className="relative overflow-hidden border-y border-border bg-muted/60 py-4 select-none"
    >
      <div className="marquee-track flex w-max items-center gap-10 px-5">
        {items.map((item, i) => (
          <span key={i} className="flex items-center gap-10 whitespace-nowrap">
            <span className="font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground">
              {item}
            </span>
            <span className="h-1.5 w-1.5 rounded-full bg-primary/60" aria-hidden="true" />
          </span>
        ))}
      </div>
    </div>
  );
};
